import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserService } from '@services/user.service';

import * as moment from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AtlasDatepickerOnlyYearComponent),
  multi: true
};

const noop = () => {};

/** @title Basic datepicker */
@Component({
  selector: 'wsb-atlas-datepicker-only-years',
  templateUrl: 'atlas-datepicker-only-year.component.html',
  styleUrls: ['atlas-datepicker-only-year.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
  standalone: false
})
export class AtlasDatepickerOnlyYearComponent implements ControlValueAccessor, OnInit, OnDestroy {
  public mask = {
    guide: true,
    showMask: true,
    // keepCharPositions : true,
    mask: '0000'
  };
  @Input() format: string;
  private userSubscription: Subscription;
  innerValue: Date;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change: EventEmitter<any> = new EventEmitter();

  @Input() public min;
  @Input() public max;

  dateFormat = null;
  dateFormatMoment = null;

  // Placeholders for the callbacks which are later provided
  // by the Control Value Accessor
  // @ts-ignore
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userSubscription = this.userService.getAuthenticationState().subscribe(loggedUser => {
      if (loggedUser.preferences.dateFormat === 'dd-MM-yyyy') {
        // MM-dd-yyyy
        this.dateFormat = 'yyyy';
        this.dateFormatMoment = 'YYYY';
      } else {
        this.dateFormat = 'yyyy';
        this.dateFormatMoment = 'YYYY';
      }
      // this.innerValue = new Date();
    });
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

  // get accessor
  get value(): Date | string {
    // @ts-ignore
    if (isNaN(this.innerValue)) {
      if (this.format) {
        return '';
      }
      return null;
    }
    if (this.format && this.innerValue) {
      if (this.format === 'date') {
        return moment(this.innerValue).format('YYYY');
      }
    }
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: Date | string) {
    if (this.format && v) {
      if (this.format === 'date') {
        this.innerValue = moment(v, 'YYYY').toDate();
      }
    } else {
      if (v !== this.innerValue) {
        this.innerValue = v as Date;
      }
    }
  }

  // get accessor
  get valueIn(): Date {
    // @ts-ignore
    if (isNaN(this.innerValue)) {
      return null;
    }
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set valueIn(v: Date) {
    if (v !== this.innerValue) {
      // @ts-ignore
      if (isNaN(this.innerValue)) {
        this.innerValue = null;
      }
      this.innerValue = v;
    }
    this.onChangeCallback(this.value);
  }

  // Occured value changed from module
  writeValue(value: any): void {
    if (value !== this.innerValue) {
      if (this.format && value) {
        if (this.format === 'date') {
          this.innerValue = moment(value, 'YYYY').toDate();
        }
      } else {
        this.innerValue = value;
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  onChangeYear(event, datepicker: MatDatepicker<moment.Moment>) {
    this.value = event;
    this.onBlur();
    if (this.change) {
      this.change.emit(this.value);
    }
    datepicker.close();
  }

  todate(value) {
    this.value = moment(value, this.dateFormatMoment).toDate();
  }

  onBlur() {
    this.onChangeCallback(this.value);
  }
}
